<template>
  <div class="c-nav-slider__item" :class="{ 'c-nav-slider__item--expanded': isExpanded, 'c-nav-slider__item--active': isActive, 'c-nav-slider__item--angle-right': hasDropdown || (isActive && link), 'c-nav-slider__item--angle-down': isActive && !link }">
    <a class="c-nav-slider__item-link" :href="link" v-if="link">{{ title }}</a>
    <span class="c-nav-slider__item-link" v-if="!link" @click="toggle">{{ title }}</span>
    <slot></slot>
  </div>
</template>

<script lang="ts">
import { Component, Prop } from 'vue-property-decorator';
import { EventBus } from '../helpers/bus';
import BaseComponent from './Base';

@Component
export default class NavSliderItem extends BaseComponent {
  @Prop({ type: Number, default: null }) public readonly level: number | null;
  @Prop({ type: String, required: true }) public readonly title: string;
  @Prop({ type: String, default: null }) public readonly link: string | null;
  @Prop({ type: Boolean, default: false }) public readonly isActive: boolean;

  protected isExpanded: boolean = false;

  public get hasDropdown(): boolean {
    return this.$slots.hasOwnProperty('default');
  }

  protected mounted(): void {
    if (this.level === null) {
      return;
    }
    EventBus.$on('mobileMenu:reset', this.onReset);
    EventBus.$on('mobileMenu:level:enter', this.onEnter);
    EventBus.$on('mobileMenu:level:leave', this.onLeave);
  }

  protected beforeUnmount(): void {
    if (this.level === null) {
      return;
    }
    EventBus.$off('mobileMenu:reset', this.onReset);
    EventBus.$off('mobileMenu:level:enter', this.onEnter);
    EventBus.$off('mobileMenu:level:leave', this.onLeave);
  }

  protected onReset(): void {
    this.isExpanded = false;
  }

  protected onEnter({ guid }: { level: number, guid: string }): void {
    this.isExpanded = this.isExpanded || this.uniqId === guid;
  }

  protected onLeave({ level }: { level: number }): void {
    if ((this.level as number) < level) {
      return;
    }
    this.isExpanded = false;
  }

  protected toggle(): void {
    if (this.level !== null) {
      EventBus.$emit('mobileMenu:level:enter', { level: this.level + 1, guid: this.uniqId });
    }
  }
}
</script>
